import React from 'react';
import LoadingCard from '../../../../components/loadingCard';

const Waiting = ({ for: _for = false, children }) => {
    return _for ? children : <LoadingCard loading />;
};

export default Waiting;
